import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";
import Button from "../../components/ui/Button";
import { authService } from "../../services/auth.service";

const ForgotPassword = () => {
  const { t } = useTranslation("auth");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setIsLoading(true);
    try {
      await authService.forgotPassword(email);
    } catch {
      // swallow — never disclose whether email exists
    } finally {
      setIsLoading(false);
      setSubmitted(true);
    }
  };

  return (
    <Layout showSidebar={false}>
      <div className="flex min-h-[80vh] items-center justify-center">
        <div className="w-full max-w-md bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 space-y-6">
          {submitted ? (
            <div className="text-center space-y-4">
              <div className="text-5xl">📧</div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                {t("forgotPassword.sentTitle")}
              </h2>
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                {t("forgotPassword.sentHint")}
              </p>
              <Link
                to="/login"
                className="inline-block text-sm text-blue-600 hover:text-blue-500 dark:text-blue-400"
              >
                ← {t("forgotPassword.backToLogin")}
              </Link>
            </div>
          ) : (
            <>
              <div className="text-center">
                <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
                  {t("forgotPassword.title")}
                </h2>
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                  {t("forgotPassword.hint")}
                </p>
              </div>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    {t("forgotPassword.email")}
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="appearance-none relative block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 placeholder-gray-500 text-gray-900 dark:text-white dark:bg-gray-700 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder={t("forgotPassword.emailPlaceholder")}
                  />
                </div>
                <Button
                  type="submit"
                  disabled={isLoading || !email}
                  className="flex w-full justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isLoading ? t("forgotPassword.sending") : t("forgotPassword.submit")}
                </Button>
                <div className="text-center">
                  <Link
                    to="/login"
                    className="text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                  >
                    ← {t("forgotPassword.backToLogin")}
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ForgotPassword;
